<div class="flex-container">
  <div class="container-fluid">
    <div class="container">
      <app-home-heading-contianer></app-home-heading-contianer>
      <!-- <app-multicity-tab-layout ></app-multicity-tab-layout> -->
      <app-profile-strip-summary></app-profile-strip-summary>
      <app-multicity-search-engine></app-multicity-search-engine>
      <app-travel-comfort></app-travel-comfort>
    </div>
  </div>
</div>